import { message } from 'antd';
import { Book1, Code, Setting2, Shop } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import admin from 'utils/icon/icon_admin_managemen.svg';

// * 여러 가지 const 값

/// jspreadsheet 라이센스
export const JspreadLicense =
  'NGM3YWZiOTA0NjdmMzVjOWVlNWU4YzI3YjU4YTM5OTc2YWY0MTE2MWE4MDhmOWU3NGRmMTFjMjI2ODFiMzEyMWM2YzQyNTA0MTZkNDhjZDdlOTUwYjY5YmE3MDM1YWVmMTMwNmZjNGFkODllOGIzODQ2ODZlNDQ4NGY5MTc2NzQsZXlKdVlXMWxJam9pU0VvZ1RHVmxJaXdpWkdGMFpTSTZNVGN4TXpZMU5EQXdNQ3dpWkc5dFlXbHVJanBiSW14dlkyRnNhRzl6ZENJc0ltdGxkbWx1TG5CcFkydHBjM011WTI5dElpd2ljR2xqYTJsemN5NWpiMjBpTENKc2IyTmhiR2h2YzNRaVhTd2ljR3hoYmlJNklqSWlMQ0p6WTI5d1pTSTZXeUoyTnlJc0luWTRJaXdpZGpraVhYMD0=';

// DLC 에피소드 스토리 종류

// * 일반 유저 메뉴
export const MenuListName = () => {
  const { t } = useTranslation();
  return [
    {
      name: t('constants.menuListName.workManagement'),
      nameWhenCollapse: t('constants.menuListName.workManagementCollapse'),
      path: '/story',
      key: '/story',
      icon: <Book1 size='20' color='#ffffff' />,
      iconOn: <Book1 size='20' color='#ffffff' variant='Bold' />,
    },
  ];
};

export const AdminMenuList = () => {
  const { t } = useTranslation();
  return [
    {
      name: t('constants.menuListName.assetsStock'),
      nameWhenCollapse: t('constants.menuListName.assetsStockCollapse'),
      path: '/assets',
      key: '/assets',
      icon: <Shop size='20' color='#ffffff' />,
      iconOn: <Shop size='20' color='#ffffff' variant='Bold' />,
    },
    {
      name: '관리자',
      nameWhenCollapse: '관리자',
      path: 'administration',
      key: 'administration',
      icon: <img src={admin} alt='관리자' />,
      iconOn: <img src={admin} alt='관리자' />,
      subMenus: [
        {
          name: '패키지 관리',
          path: '/package',
          key: '/package',
        },
        {
          name: '케빈유저 관리',
          path: '/manager',
          key: '/manager',
        },
        {
          name: t('constants.menuListName.multilingualManagement'),
          path: '/multilang',
          key: '/multilang',
        },
      ],
    },
  ];
};

export const ProjectPageSubMenuList = () => {
  const { t } = useTranslation();
  return [
    { name: t('constants.projectPageSubMenuList.episodes'), key: 'episode' },
    {
      name: t('constants.projectPageSubMenuList.backgrounds'),
      key: 'resource',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.backgrounds'),
      key: 'background',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.LIVEObjects'),
      key: 'liveBackground',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.miniCuts'),
      key: 'minicut',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.LIVEObjects'),
      key: 'liveObject',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.illustrations'),
      key: 'illust',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.LIVEIllustrations'),
      key: 'liveIllust',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.emoticons'),
      key: 'emoticon',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.characters'),
      key: 'character',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.costumes'),
      key: 'dress',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.sounds'),
      key: 'sound',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.commonImages'),
      key: 'design',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.nameTags'),
      key: 'nametag',
      type: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.coinCurrencyImages'),
      key: 'coinImg',
      type: 'resource',
    },
    { name: t('constants.projectPageSubMenuList.missions'), key: 'mission' },
    {
      name: t('constants.projectPageSubMenuList.loadingImages'),
      key: 'epiLoading',
    },
    { name: t('constants.projectPageSubMenuList.abilities'), key: 'ability' },
    {
      name: t('constants.projectPageSubMenuList.storyDecoration'),
      key: 'decoration',
    },
    { name: t('constants.projectPageSubMenuList.endingHints'), key: 'hint' },
    {
      name: t('constants.projectPageSubMenuList.resource'),
      key: 'resource',
    },
    {
      name: t('constants.projectPageSubMenuList.characters'),
      key: 'character',
    },
    {
      name: 'DLC',
      key: 'dlc',
    },
    {
      name: t('constants.projectPageSubMenuList.operation'),
      key: 'operation',
    },
    {
      name: t('constants.projectPageSubMenuList.dashboard'),
      key: 'dashboard',
    },
    // { name: '로비 화면', key: 'lobby' },
    // { name: '타임딜', key: 'timeDeal' },
  ];
};

// 요일
export const DaysList = [
  {
    key: 0,
    label: '월',
    text: '월',
    value: '1',
  },
  {
    key: 1,
    label: '화',
    text: '화',
    value: '2',
  },
  {
    key: 2,
    label: '수',
    text: '수',
    value: '3',
  },
  {
    key: 3,
    label: '목',
    text: '목',
    value: '4',
  },
  {
    key: 4,
    label: '금',
    text: '금',
    value: '5',
  },
  {
    key: 5,
    label: '토',
    text: '토',
    value: '6',
  },
  {
    key: 6,
    label: '일',
    text: '일',
    value: '0',
  },
];
// 작품 관리 - 작품 정보 수정 - 작품 상태 체크박스 항목
export const stateOptionList = [
  { key: 0, label: '공개', value: 'is_public' },
  { key: 1, label: '완결', value: 'is_complete' },
  { key: 2, label: '타이틀만 공개', value: 'is_lock' },
  { key: 3, label: '작품 배포', value: 'is_deploy' },
];
// 작품 관리 - 작품 정보 수정 - 기능 체크박스 항목
export const functionOptionList = [
  { key: 0, label: '크레딧', value: 'is_credit' },
];

// 에피소드 스토리 종류
export const EpisodeTypeList = [
  { key: 0, value: 'chapter', text: '에피소드' },
  { key: 1, value: 'side', text: '사이드' },
  { key: 2, value: 'ending', text: '엔딩' },
];
// 오토메 에피소드 스토리 종류
export const OtomeEpisodeTypeList = () => {
  const { t } = useTranslation();
  return [
    {
      key: 0,
      value: 'chapter',
      text: t(
        'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.episode',
      ),
    },
    {
      key: 1,
      value: 'side',
      text: t(
        'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.side',
      ),
    },
    {
      key: 2,
      value: 'ending',
      text: t(
        'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.ending',
      ),
    },
    {
      key: 3,
      value: 'prologue',
      text: t(
        'storyEpisodeID.storyTabMenuList.episodeContent.header.registerEpisodeModal.prologue',
      ),
    },
  ];
};
// DLC 에피소드 스토리 종류
export const DlcEpisodeTypeList = [
  { key: 0, value: 'chapter', text: '에피소드' },
  { key: 1, value: 'ending', text: '엔딩' },
];
// 에피소드 출시 상태
export const EpisodeStatusList = [
  {
    key: 0,
    value: 0,
    text: '제작',
  },
  {
    key: 1,
    value: 1,
    text: '검수',
  },
  {
    key: 2,
    value: 2,
    text: '출시',
  },
];
// 즉시 공개 & 예약
export const ShowState = [
  { key: 0, value: '-', text: '즉시 공개' },
  { key: 1, value: 'reservation', text: '예약' },
];
// 엔딩 종류
export const EndingType = [
  { key: 0, value: 'final', text: '최종 엔딩' },
  { key: 1, value: 'hidden', text: '히든 엔딩' },
];
// 미션 타입 옵션 모음
export const MissionTypeOption = [
  {
    key: 0,
    value: 'episode',
    text: '에피소드 플레이',
  },
  {
    key: 1,
    value: 'drop',
    text: '드롭 미션',
  },
  {
    key: 2,
    value: 'event',
    text: '사건',
  },
  // {
  //   key: 0,
  //   value: 'platform',
  //   text: '일반 미션(플랫폼)',
  // },
  // {
  //   key: 4,
  //   value: 'illust',
  //   text: '앨범 수집',
  // },
  // {
  //   key: 5,
  //   value: 'all',
  //   text: '전체 달성',
  // },
];
// 사운드 타입 리스트
export const soundTypeList = [
  {
    key: 0,
    text: '효과음',
    value: 'se',
  },
  {
    key: 1,
    text: '배경음악',
    value: 'bgm',
  },
  {
    key: 2,
    text: '음성',
    value: 'voice',
  },
];
export const missionTypeList = [
  {
    key: 0,
    value: 0,
    name: '출석',
  },
  {
    key: 1,
    value: 1,
    name: '열람',
  },
  {
    key: 2,
    value: 2,
    name: '횟수',
  },
  {
    key: 3,
    value: 3,
    name: '플레이',
  },
  {
    key: 4,
    value: 4,
    name: '공유',
  },
];
export const userSearchOptionList = [
  {
    key: 0,
    name: 'UID',
    value: 'uid',
  },
  {
    key: 1,
    name: 'Gamebase ID',
    value: 'gamebase',
  },
];

//공개여부
export const PublicState = () => {
  const { t } = useTranslation();
  return [
    {
      key: 0,
      value: 0,
      text: t('constants.publicState.private'),
    },
    {
      key: 1,
      value: 1,
      text: t('constants.publicState.public'),
    },
  ];
};
//배열 (메인 카테고리 리스트)
export const arrayList = [
  {
    key: 0,
    value: '1*N',
    text: '1*N',
  },
  {
    key: 0,
    value: '2*N',
    text: '2*N',
  },
];

//공개여부 (+팝업공개, 모두공개) 인앱상점
export const PublicStateEnhance = () => {
  const { t } = useTranslation();
  return [
    {
      key: 0,
      value: 0,
      text: t('constants.publicStateEnhance.unDisclosed'),
    },
    {
      key: 1,
      value: 1,
      text: t('constants.publicStateEnhance.open'),
    },
    {
      key: 2,
      value: 2,
      text: t('constants.publicStateEnhance.popupDisclosure'),
    },
    {
      key: 3,
      value: 3,
      text: t('constants.publicStateEnhance.revealAll'),
    },
    {
      key: 4,
      value: 4,
      text: t('constants.publicStateEnhance.workAttribution'),
    },
  ];
};
//체크여부
export const checkState = [
  {
    key: 0,
    value: 0,
    text: 'x',
  },
  {
    key: 1,
    value: 1,
    text: 'O',
  },
];
//완결 여부
export const completeState = [
  {
    key: 0,
    value: 0,
    text: '연재',
  },
  {
    key: 1,
    value: 1,
    text: '완결',
  },
];

//확정 여부
export const okState = [
  {
    key: 0,
    value: 1,
    text: '확정',
  },
  {
    key: 0,
    value: 0,
    text: '미확정',
  },
];
// 확인 유무부
export const confirmState = [
  {
    key: 0,
    value: 0,
    text: '미확인',
  },
  {
    key: 1,
    value: 1,
    text: '확인',
  },
];
// 플랫폼 재화관리 체크박스
export const currencyProperty = [
  { key: 0, label: '코인 상품 재화', value: 'is_coin' },
  { key: 1, label: '미션 보상', value: 'mission_reward' },
  { key: 2, label: '사용 여부', value: 'is_use' },
  { key: 3, label: '소모성', value: 'consumable' },
  { key: 4, label: '유일성', value: 'is_unique' },
  { key: 5, label: '능력치 여부', value: 'is_ability' },
];
// 출석 보상 - 타입 기간
export const PeriodType = () => {
  const { t } = useTranslation();
  return [
    {
      key: 0,
      value: 7,
      text: t('constants.periodType.7days'),
    },
    {
      key: 1,
      value: 15,
      text: t('constants.periodType.15days'),
    },
    {
      key: 2,
      value: 30,
      text: t('constants.periodType.30days'),
    },
    {
      key: 3,
      value: -1,
      text: t('constants.periodType.infinite'),
    },
  ];
};
// 출석 보상 - 반복 여부
export const loopType = [
  {
    key: 0,
    value: 0,
    text: '반복 안함',
  },
  {
    key: 1,
    value: 1,
    text: '반복',
  },
];
// 운영관리-메일관리-검색 조건
export const sendToType = [
  {
    key: 0,
    value: 'all',
    text: '전체',
  },
  {
    key: 1,
    value: 'some',
    text: '일부',
  },
];
// 발송 상태
export const isCompleteData = [
  {
    key: 0,
    value: 0,
    name: '발송 전',
  },
  {
    key: 1,
    value: 1,
    name: '발송 실패',
  },
  {
    key: 2,
    value: 2,
    name: '발송 완료',
  },
  {
    key: 3,
    value: 3,
    name: '발송 취소',
  },
];
export const currencyData = [
  {
    key: 0,
    value: 'gem',
    text: '스타',
  },
  {
    key: 1,
    value: 'coin',
    text: '코인',
  },
  // {
  //   key: 2,
  //   value: 'OneTime',
  //   text: '1회 플레이권',
  // }, //todo 이거 플랍에서만 써서 지워도돼
];
/// 공지사항 타입
export const noticeTypeList = [
  {
    key: 0,
    value: 'notice',
    text: '공지사항',
  },
  {
    key: 1,
    value: 'event',
    text: '이벤트',
  },
];
//주관식, 객관식 (운영-설문조사)
export const answerTypeList = [
  {
    key: 0,
    value: 0,
    text: '객관식',
  },
  {
    key: 1,
    value: 1,
    text: '주관식',
  },
];

//다중선택 가능, 불가능 (운영-설문조사)
export const AnswerCheckType = () => {
  const { t } = useTranslation();
  return [
    {
      key: 0,
      value: 0,
      text: t('constants.answerCheckType.impossible'),
    },
    {
      key: 1,
      value: 1,
      text: t('constants.answerCheckType.yes'),
    },
  ];
};
/// 운영체제(기종)
export const osOptions = [
  {
    key: 0,
    value: 'all',
    text: '전체',
  },
  {
    key: 1,
    value: 'iOS',
    text: '아이폰',
  },
  {
    key: 2,
    value: 'Android',
    text: '안드로이드',
  },
];
export const contactType = [
  { key: 0, value: 'pier', text: '피어' },
  { key: 1, value: 'ifyou', text: '이프유' },
];
export const essentialTagList = [
  { key: 0, value: 0, text: '웹툰 원작' },
  { key: 1, value: 1, text: '오리지날' },
];
// 오토메 여부 구분. 0 : 이프유 비주얼노벨 / 1 : 싱글 오토메
export const OtomeCheckType = [
  { key: 0, value: 0, text: '이프유 비주얼노벨' },
  { key: 1, value: 1, text: '싱글 오토메' },
];
// 말풍선 세트 수정
export const textAlignList = [
  {
    key: 0,
    value: 'left',
    text: '왼쪽',
  },
  {
    key: 1,
    value: 'center',
    text: '중앙',
  },
  {
    key: 2,
    value: 'right',
    text: '오른쪽',
  },
];
// 운영-프로모션 타입
export const promotionTypeList = [
  {
    key: 0,
    value: 'none',
    text: '선택 없음',
  },
  {
    key: 1,
    value: 'project',
    text: '작품으로 이동',
  },
  {
    key: 2,
    value: 'page',
    text: '페이지로 이동',
  },
  {
    key: 3,
    value: 'notice',
    text: '공지사항으로 이동',
  },
];

// 판매 - 재화명
export const currencyTypeList = [
  {
    key: 0,
    value: '테두리',
    text: '테두리',
  },
  {
    key: 1,
    value: '초상화',
    text: '초상화',
  },
  {
    key: 2,
    value: '배경',
    text: '배경',
  },
  {
    key: 3,
    value: '스티커',
    text: '스티커',
  },
  {
    key: 4,
    value: '스탠딩',
    text: '스탠딩(캐릭터)',
  },
  {
    key: 5,
    value: '말풍선',
    text: '말풍선(대사)',
  },
  {
    key: 6,
    value: '세트',
    text: '세트',
  },
];

export const couponType = [
  { key: 0, text: '시리얼', value: 'serial' },
  { key: 1, text: '키워드', value: 'keyword' },
];

export const conditionType = [
  { key: 0, value: 0, text: '없음' },
  { key: 1, value: 1, text: '능력치' },
  { key: 2, value: 2, text: '날짜' },
];

export const styleDisplayCenter = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const natureNumFilterFunc = (e) => {
  var pattern_spc = /[.-]/;
  if (pattern_spc.test(e)) {
    message.error('소수점 및 음수는 올 수 없습니다.');
    return true; //[. -] 이 들어간 경우. if문 간소화 하기위해 true로 설정
  } else {
    return false;
  }
};

export const pointNumFilterFunc = (e) => {
  var pattern_spc = /[.]/;
  if (pattern_spc.test(e)) {
    message.error('소수점은 올 수 없습니다.');
    return true; //[. -] 이 들어간 경우. if문 간소화 하기위해 true로 설정
  } else {
    return false;
  }
};

export const negativeFilterFunc = (e) => {
  var pattern_spc = /[-]/;
  if (pattern_spc.test(e)) {
    message.error('0 이하로는 올 수 없습니다.');
    return true; //[. -] 이 들어간 경우. if문 간소화 하기위해 true로 설정
  } else {
    return false;
  }
};

export const productType = [
  { key: 0, value: 'base', text: '일회성' },
  { key: 1, value: 'limited', text: '영구적' },
];

export const localizeCategory = [
  {
    value: 'common',
    text: '공용',
  },
  {
    value: 'package',
    text: '패키지',
  },
  {
    value: 'platform',
    text: '플랫폼',
  },
];

export const tableLimit = 25;
